import { render, staticRenderFns } from "./ServicePageHeader.vue?vue&type=template&id=5a032cbf&scoped=true"
import script from "./ServicePageHeader.vue?vue&type=script&lang=js"
export * from "./ServicePageHeader.vue?vue&type=script&lang=js"
import style0 from "./ServicePageHeader.vue?vue&type=style&index=0&id=5a032cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a032cbf",
  null
  
)

export default component.exports